export default __webpack_public_path__ + "4ae1a9e1f9546a28e77af881070cbd2d.webp";